import { ConfigService } from '@services/config-service';
import { Component, Element, Host, State, h } from '@stencil/core';
import { pathStore } from '@store/path-store';
import { If } from '@utils/If';

@Component({
  tag: 'blur-loader',
  styleUrl: 'blur-loader.scss',
  shadow: true,
})
export class BlurLoader {
  pageLoaderEl: HTMLElement;
  faciaBaseUrl: string = ConfigService.cardFaciaCdnUrl
  @Element() el!: HTMLElement;
  @State() title: string = 'Loading...';
  @State() subTitle: string = '';
  @State() status: 'loading' | 'failed' = 'loading';
  @State() cardFaciaUrl = '';

  showLoader = (event: any) => {
    const { title = '', cardFaciaUrl = 'default.webp', subTitle = '', status = 'loading' } = event?.detail || {};
    this.title = title;
    this.cardFaciaUrl = this.faciaBaseUrl + cardFaciaUrl;
    this.subTitle = subTitle;
    this.status = status;
    this.pageLoaderEl?.classList.add('active');
  }

  hideLoader = () => {
    this.pageLoaderEl?.classList.remove('active');
  }

  connectedCallback() {
    if (typeof window !== 'undefined') {
      window.addEventListener('show-loader', this.showLoader);
      window.addEventListener('hide-loader', this.hideLoader);
    }
  }

  disconnectedCallback() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('show-loader', this.showLoader);
      window.removeEventListener('hide-loader', this.hideLoader);
    }
  }

  render() {
    const assetPath = pathStore.assetPath;
    return (
      <Host>
        <div class="page-loading" ref={el => this.pageLoaderEl = el as HTMLElement}>
          <div class="p-7 w-xs flex bg-white rounded-4xl flex-col items-center justify-center">
            <If
              condition={this.status === 'loading'}
              children={<div class="card-container">
                <div class="card blue bg-gray-400">
                  <div class="magnetic-strip" />
                  <div class="logo-hologram" />
                  <div class="card-number" >0000 0000 0000 000</div>
                  <div class="flex gap-4">
                    <div class="card-validity">valid thru: 00/00</div>
                    <div class="card-validity">cvv: 000</div>
                  </div>
                </div>
                <div
                  style={{
                    backgroundImage: `url(${this.cardFaciaUrl})`,
                  }}
                  class="card yellow bg-gray-500 bg-cover bg-center">
                  <div class="h-3 " />
                  <If
                    condition={!this.cardFaciaUrl}
                    children={<div>
                      <div class="chip " />
                      <div class="card-number text-black">0000 0000 0000 000</div>
                    </div>}
                  />
                </div>
              </div>}
            />
            <If
              condition={this.status === 'failed'}
              children={<img class='mb-5' width={60} height={60} src={assetPath + 'icons/alert.svg'} />}
            />
            <span class={`font-bold ${this.status === 'failed' ? 'text-sm text-gray-700' : 'text-lg'} w-60 block text-center`}>{this.title}</span>
            <If
              condition={!!this.subTitle}
              children={<span class="text-xs w-60 text-gray-700 mt-3 block text-center">{this.subTitle}</span>}
            />
          </div>
        </div>
      </Host>
    );
  }
}
